import { AnalyticsService } from './AnalyticsService';
import { getAnalyticsConfig } from './config';

const config = getAnalyticsConfig('student');

const analyticsConfig = {
  enabled: config.enabled,
  debug: config.debug,
  appType: 'student' as const,
  providers: [{
    name: 'posthog',
    key: config.apiKey,
  }],
};

export const analyticsService = new AnalyticsService(analyticsConfig);
export * from './types';
export * from './adapters/PostHogAdapter';
export { StudentPageMapper as PageMapper } from './pageMappingStudent';
export type { PageInfo } from './pageMappingStudent';
